import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('section-header', []);

type SectionHeaderController = angular.IStrictController;

module.component('sectionHeader', {
    template: template,
    bindings: {
        icon: '<?'
    },
    transclude: true,
    controller: function(this: SectionHeaderController) {
        this.$onInit = () => {};
    }
});

export { module };
